import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RANGE_FILTER } from '@as-react/common-types';
import { Link, Stack } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { AppliedFilterItem } from './AppliedFilterItem';
export const AppliedFilterRow = ({ flattenedActiveFilters, onToggleFilter, onRemoveAllFilters, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    if (!(!!flattenedActiveFilters && flattenedActiveFilters.length > 0)) {
        return null;
    }
    const getKey = (activeFilterItem) => activeFilterItem.filterType === RANGE_FILTER
        ? activeFilterItem.filterOn
        : `${activeFilterItem.filterOn}_${activeFilterItem.filterKey}`;
    return (_jsxs(Stack, { gap: "3", align: "center", wrap: "wrap", children: [flattenedActiveFilters.map(activeFilterItem => (_jsx(AppliedFilterItem, { onToggleFilter: onToggleFilter, activeFilterItem: activeFilterItem }, getKey(activeFilterItem)))), "\u2003", _jsx(Link, { onClick: onRemoveAllFilters, size: "sm", testId: "clear-all-applied-filters", children: t('product.lister.filter.clear') })] }));
};
